<template>
  <div class="seal-borrow">
    <h2 class="seal-borrow-title">印章外借流程</h2>
    <el-card shadow="never">
      <div class="seal-borrow-content">
        <!--操作栏-->
        <div class="option">
          <el-form size="mini" :model="queryParams.params" inline>
            <el-form-item prop="name" label="申请人">
              <el-input v-model="queryParams.params.name" clearable />
            </el-form-item>
            <el-form-item prop="applyDate" label="申请日期">
              <el-date-picker
                v-model="queryParams.params.applyDate"
                clearable
                type="date"
              ></el-date-picker>
            </el-form-item>
            <el-form-item prop="companyName" label="公司名称">
              <el-select v-model="queryParams.params.companyName" clearable>
                <el-option label="利元亨" value="利元亨" />
                <el-option label="索沃" value="索沃" />
                <el-option label="玛克" value="玛克" />
                <el-option label="马安分公司" value="马安分公司" />
                <el-option label="柏塘分公司" value="柏塘分公司" />
                <el-option label="杨村分公司" value="杨村分公司" />
              </el-select>
            </el-form-item>
            <el-form-item prop="sealType" label="印章类型">
              <el-select v-model="queryParams.params.sealType" clearable>
                <el-option label="公章" value="公章" />
                <el-option label="合同专用章" value="合同专用章" />
                <el-option label="业务章" value="业务章" />
                <el-option label="业务专用章1" value="业务专用章1" />
                <el-option label="业务专用章2" value="业务专用章2" />
                <el-option label="其他章" value="其他章" />
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="onSearch">搜索</el-button>
              <el-button type="danger" @click="exportForm">导出</el-button>
            </el-form-item>
          </el-form>
        </div>
        <el-card shadow="hover" style="margin: 10px 80px 0px 80px">
          <div class="seal-data">
            <el-table
              :data="sealData"
              border
              max-height="610px"
              stripe
              class="table"
            >
              <el-table-column
                type="index"
                label="序号"
                fixed
                align="cneter"
              ></el-table-column>
              <el-table-column
                label="申请人"
                prop="name"
                width="100px"
                align="center"
              ></el-table-column>
              <el-table-column
                label="申请日期"
                prop="applyDate"
                align="center"
              ></el-table-column>
              <el-table-column
                label="公司名称"
                prop="companyName"
                align="center"
              ></el-table-column>
              <el-table-column
                label="印章类型"
                prop="sealType"
                align="center"
              ></el-table-column>
              <el-table-column
                label="预计外借时间"
                prop="planBorrowDate"
                align="center"
              ></el-table-column>
              <el-table-column
                label="预计归还时间"
                prop="planBackDate"
                align="center"
              ></el-table-column>
              <el-table-column
                label="实际借出时间"
                prop="realBorrowDate"
                align="center"
              ></el-table-column>
              <el-table-column
                label="实际归还时间"
                prop="realBackDate"
                align="center"
              ></el-table-column>
              <el-table-column
                label="归还人"
                prop="returnerName"
                width="100px"
                align="center"
              ></el-table-column>
              <el-table-column label="操作" align="center" fixed="right">
                <template slot-scope="scope">
                  <el-button size="mini" round type="primary">外 借</el-button>
                  <el-button size="mini" round type="success">归 还</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="flex-row flex-center">
            <el-pagination
              background
              size="mini"
              layout="total, sizes, prev, pager, next, jumper"
              :page-sizes="[10, 30, 50, 100]"
              :page-size.sync="queryParams.size"
              :total="totalCount"
              :current-page.sync="queryParams.page"
              @current-change="getSealData"
              @size-change="getSealData"
            >
            </el-pagination>
          </div>
        </el-card>
      </div>
    </el-card>
  </div>
</template>

<script>
import * as Api from "@/api/sealBorrowApi";
import axiosl from "axios";
export default {
  data() {
    return {
      sealData: [], //印章数据
      queryParams: {
        page: 1,
        size: 10,
        params: {
          name: "", //申请人
          applyDate: "", //申请时间
          companyName: "", //公司名称
          sealType: "", //印章类型
        },
      },
      totalCount: 0, //总条数
    };
  },
  mounted() {
    this.getSealData();
  },
  methods: {
    getSealData() {
      let params = JSON.parse(JSON.stringify(this.queryParams));
      Api.getListPage(params).then((res) => {
        if (res.code != "0000") {
          this.$message({
            type: "error",
            message: res.msg,
          });
        }
        this.totalCount = res.data.totalElements;
        this.sealData = res.data.content;
      });
    },
    onSearch() {
      this.queryParams.page = 1;
      this.getSealData();
    },
    exportForm() {
      //导出数据
      if (this.totalCount === 0) {
        this.$message.info("没有可以导出的数据");
        return;
      }
      let _this = this;
      const size = this.queryParams.size;
      this.queryParams.size = this.totalCount > 10000 ? 10000 : this.totalCount;
      let token = document.cookie.match(
        new RegExp("(^| )tenant_user_token=([^;]*)(;|$)")
      )[2];
      axiosl
        .post("/eip-mapp-oa-server/oa_seal_form/export", this.queryParams, {
          headers: { keyId: token },
          responseType: "blob",
        })
        .then((res) => {
          this.queryParams.size = size;
          _this.convertRes2Blob(res);
        });
    },
    convertRes2Blob(response) {
      let filename = "印章外借数据查询导出结果.xls";
      // 将二进制流转为blob
      const blob = new Blob([response.data], {
        type: "application/octet-stream",
      });
      if (typeof window.navigator.msSaveBlob !== "undefined") {
        // 兼容IE，window.navigator.msSaveBlob：以本地方式保存文件
        window.navigator.msSaveBlob(blob, decodeURI(filename));
      } else {
        // 创建新的URL并指向File对象或者Blob对象的地址
        const blobURL = window.URL.createObjectURL(blob);
        // 创建a标签，用于跳转至下载链接
        const tempLink = document.createElement("a");
        tempLink.style.display = "none";
        tempLink.href = blobURL;
        tempLink.setAttribute("download", decodeURI(filename));
        // 兼容：某些浏览器不支持HTML5的download属性
        if (typeof tempLink.download === "undefined") {
          tempLink.setAttribute("target", "_blank");
        }
        // 挂载a标签
        document.body.appendChild(tempLink);
        tempLink.click();
        document.body.removeChild(tempLink);
        // 释放blob URL地址
        window.URL.revokeObjectURL(blobURL);
      }
    },
  },
};
</script>

<style  scoped>
.seal-borrow {
  text-align: center;
  max-width: 1800px;
  margin: auto;
}
.seal-borrow-title {
  color: transparent;
  -webkit-text-stroke: 1px #409eff;
  letter-spacing: 0.1em;
  font-size: 47px;
}
::v-deep .el-table thead th {
  height: 62px;
  color: #525252;
  background-color: #f6f8fa;
}
.option {
  margin-bottom: 25px;
}
.seal-data {
  display: flex;
  flex-direction: column;
  margin: auto;
  padding-bottom: 22px;
}
</style>

